import { create } from "zustand";
import { persist } from "zustand/middleware";
export var useKYCStore = create(persist(function (set) { return ({
    documentType: "",
    setDocumentType: function (type) { return set({ documentType: type }); },
}); }, {
    name: "kyc-store",
}));
